var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 250,
    viewBox: "0 0 105 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.084%",
    y1: "25.765%",
    x2: "113.188%",
    y2: "38.749%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAA58F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87594C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.084%",
    y1: "26.144%",
    x2: "113.188%",
    y2: "38.925%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAA58F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87594C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.24 103.543s-.54 19.035 0 20.962c.447 1.607.984 5.302.984 5.302s-.965 6.216 2.842 6.608c1.848.19 9.075 1.215 10.955 0 2.26-1.46 4.98-5.41 4.98-5.708 0-1.06-2.137-15.207-2.137-15.207C75.555 115.5 61.05 94 61.05 94l-4.81 9.543z",
    fill: "#CC947B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.826 11.243s-2.718 4.183-3.3 5.1c-.85 1.344-1.313 6.068-1.313 6.068l1.313 4.423 2.148 3.39 2.148 1.13h3.222c1.074 0 4.297-2.26 4.297-2.26l3.223-3.39s6.605-12.67 6.963-17.19L16.47.864 5.826 11.243z",
    fill: "url(#a)",
    transform: "translate(12 108) rotate(2 12.869 16.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.802 134.387s1.013-2.493 1.27-3.85c.282-1.487.345-4.682.345-4.682l-1.947-2.582-1.753-.745-2.486.26c-.827.09-3.12 2.188-3.12 2.188l-.054 7.44 7.746 1.97z",
    fill: "#F9DFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.288 103.946c-.23.186-2.148 5.705-2.148 5.705s-.492 2.4-1.074 3.29c-.85 1.302-1.074 4.386-1.074 4.386v6.58l2.148 3.288 2.148 1.096h3.222c1.074 0 4.297-2.193 4.297-2.193l3.222-3.29s6.604-12.286 6.962-16.672L36.03 99.29s-6.676 1.388-10.742 4.656z",
    id: "Path-105",
    fill: "url(#b)",
    transform: "rotate(25 31.992 113.79)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DAA58F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 101v-1.076s.145-2.07 1-2.924l3-3.058s3.722-1.843 4-1.982c.814-.406 6.916-2.54 9.665-3.497L25 88l11-2s3.898 8.195 6 6.973c1.898-1.104 7-1.994 7-1.994l9 .996L63 84l11 14.954L87 116.9s1.786 3.752 2 6.1c.12 1.308 0 5.863 0 5.863s-.82 5.9-1 6.978c-.153.918-5 17.946-5 17.946L78 169l-6 16-1 6.67-7 3.988-17 5.98s-9 .998-14 4.986c-2.406 1.92.61-1.536-1-6.624-.702-2.22 1 3.658 0-11-.22-3.212-.783-5.7-2-13s-3-12.015-3-17c0-.73-1-11.018 1-17 2-5.982 4-13.137 4-13.137l5-6.98s17.254 7.37 20 10.117c2 2 8 3 8 3l7-1s2.845-5.613 3-7c.18-1.604-1-10.1-1-10.1L61 96.96l-6 7.976s-2.87 2.902-6 3.988C44.464 110.497 30 101 30 101l-9 4.91s-4 1.995-5 1.995h-4l-3-.997-2-.997-1-2.996V101z",
    id: "path-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 101v-1.076s.145-2.07 1-2.924l3-3.058s3.722-1.843 4-1.982c.814-.406 6.916-2.54 9.665-3.497L25 88l11-2s3.898 8.195 6 6.973c1.898-1.104 7-1.994 7-1.994l9 .996L63 84l11 14.954L87 116.9s1.786 3.752 2 6.1c.12 1.308 0 5.863 0 5.863s-.82 5.9-1 6.978c-.153.918-5 17.946-5 17.946L78 169l-6 16-1 6.67-7 3.988-17 5.98s-9 .998-14 4.986c-2.406 1.92.61-1.536-1-6.624-.702-2.22 1 3.658 0-11-.22-3.212-.783-5.7-2-13s-3-12.015-3-17c0-.73-1-11.018 1-17 2-5.982 4-13.137 4-13.137l5-6.98s17.254 7.37 20 10.117c2 2 8 3 8 3l7-1s2.845-5.613 3-7c.18-1.604-1-10.1-1-10.1L61 96.96l-6 7.976s-2.87 2.902-6 3.988C44.464 110.497 30 101 30 101l-9 4.91s-4 1.995-5 1.995h-4l-3-.997-2-.997-1-2.996V101z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.636 121.878c4.727-1.268 0 0 0 0s.663-2.43.733-3.705c.076-1.396-.293-4.307-.293-4.307s-5.817-1.072-6.623-.856c-.805.216-1.685 2.326-1.685 2.326s-.663 2.086-.844 3.028c-.175.908.805 3.002.805 3.002s3.18 1.78 7.906.512z",
    fill: "#EFCDBE"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F00",
    transform: "rotate(19 45 52.184)",
    x: 13.5,
    y: 8.184,
    width: 63,
    height: 88,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 103.815l3 10.592-3.555 5.135-.445.643V125l6-.963-4-.963v-2.89c0-.642 4-4.814 4-4.814h4c2.152 0 8 .963 8 .963s-12-2.89-12-3.852c0-.96-3-7.702-3-7.702L68 99l-10 4.815z",
    fillOpacity: 0.53,
    fill: "#3F140F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 197c-8.31 3.672-24 8-24 8l14 45h59s-31-61-32-61-10.976 5.338-17 8z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 209s-5-20-8-29c-5.518-16.553 1.096-38.205 2-42 .763-3.205 4-9 4-9s8.88-15.577 9-17.344c.214-3.184 0-10.892 0-10.892s-.01-9.82 0-9.902c.28-2.073 1-5.94 1-5.94s.448-2.504 1-3.96c.448-1.185 3-2.972 3-2.972s2-.99 4-.99h4l2 .99c2 .99 2 1.98 2 1.98l1 3.96V93.833l-1 8.912-1 8.912v3.96L73 187l-40 22z",
    fill: "#DAA58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 104.407l5 .797 7-.797H42zM42 102.407l5 .797 7-.797H42z",
    fillOpacity: 0.53,
    fill: "#3F140F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.906 90.46c.99.586 3.838.96 3.838.96s3.176.394 3.838 0c.94-.558.972-2.855.972-2.855s.38-3.47 0-5.75c-.188-1.114-1.116-1.85-1.28-1.933H50.08s-1.76-.055-1.915 0c-.234.082-1.357.045-1.915.64-.605.644-.638 1.92-.638 1.92l-.635 5.154s.33 1.508.93 1.863z",
    fill: "#F3D5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 188c-6.68 3.05-23.736 9.4-25 10-2.535 1.204-11 5-11 5s.48 4.44 1 6c.48 1.44 2 5 2 5l43-18s-1.022-2.97-2-5c-.948-1.97-.85-7-1-7-.095 0-3.968 2.615-7 4z",
    fill: "#E5E5E5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/redCard.609058074ba96aaa4531e1f64c03d750.svg";
export { ForwardRef as ReactComponent };